<script setup lang="ts">
import { CContainer } from '@coreui/vue-pro'
import AppSidebar from '@/components/AppSidebar.vue'
import AppFooter from '@/components/AppFooter.vue'
import AppHeader from '@/components/AppHeader.vue'
import AppSidebarNavItem from '@/components/AppSidebarNavItem.vue'
import roles from '@/config/roles.json'
import {
  IconCalendarEvent,
  IconPresentation,
  IconUsers,
  IconUserHexagon,
  IconLayoutGrid,
  IconId,
  IconCategory2,
  IconCategoryPlus,
  IconAdjustmentsHorizontal
} from '@tabler/icons-vue'
const { t } = useI18n()
const userStore = useUserStore()
const { userHasRole } = useUserStore()
</script>

<template>
  <div>
    <AppSidebar>
      <template #navList>
        <AppSidebarNavItem to="/events">
          <IconPresentation style="margin-right: 0.7rem; margin-left: -3px" stroke-width="1" size="26" />
          {{ t('Events') }}
        </AppSidebarNavItem>

        <AppSidebarNavItem to="/dashboard" class="margin_side">
          <IconCalendarEvent style="margin-right: 0.7rem; margin-left: -3px" stroke-width="1" size="26" />
          {{ t('Coming events') }}
        </AppSidebarNavItem>

        <AppSidebarNavItem to="/users" v-if="userStore.doIHaveEnoughLevel(roles.gestor.level)">
          <IconUsers style="margin-right: 0.7rem; margin-left: -3px" stroke-width="1" size="24" />
          {{ t('Users') }}
        </AppSidebarNavItem>

        <AppSidebarNavItem to="/customers" v-if="userHasRole('superadmin')">
          <IconUserHexagon style="margin-right: 0.7rem; margin-left: -3px" stroke-width="1" size="24" />
          {{ t('Customers') }}
        </AppSidebarNavItem>

        <CNavGroup>
          <template #togglerContent v-if="userHasRole('superadmin')">
            <IconLayoutGrid class="navbarIcon1" stroke-width="1.2" size="27" />
            {{ t('Stands') }}
          </template>

          <AppSidebarNavItem v-if="userHasRole('superadmin')" :to="`/stands/configuration`">
            <IconAdjustmentsHorizontal class="navbarIcon2" stroke-width="1.2" size="27" />
            {{ t('Settings') }}
          </AppSidebarNavItem>

          <AppSidebarNavItem v-if="userHasRole('superadmin')" :to="`/stands`">
            <IconLayoutGrid class="navbarIcon1" stroke-width="1.2" size="27" />
            {{ t('Stands') }}
          </AppSidebarNavItem>

          <AppSidebarNavItem v-if="userHasRole('superadmin')" :to="`/stands/aggregates`">
            <IconCategoryPlus class="navbarIcon1" stroke-width="1.2" size="27" />
            {{ t('Aggregates') }}
          </AppSidebarNavItem>

          <AppSidebarNavItem v-if="userHasRole('superadmin')" :to="`/stands/aggregates-categories`">
            <IconCategory2 class="navbarIcon1" stroke-width="1.2" size="27" />
            {{ t('Agg. categories') }}
          </AppSidebarNavItem>

          <AppSidebarNavItem v-if="userHasRole('superadmin')" :to="`/stands/billing-data`">
            <IconId class="navbarIcon1" stroke-width="1.2" size="27" />
            {{ t('Billing data') }}
          </AppSidebarNavItem>
        </CNavGroup>
      </template>
    </AppSidebar>
    <div class="wrapper d-flex flex-column min-vh-100 bg-light dark:bg-transparent">
      <AppHeader />

      <div class="body flex-grow-1">
        <CContainer fluid>
          <router-view />
        </CContainer>
      </div>

      <AppFooter />
    </div>
  </div>
</template>
